<template>
  <div class="app-download-page">
    <div class="app-download-card">
      <div class="app-download-header">
        <h1>下载悉迹AI App</h1>
        <p>选择对应平台，获取更便捷的移动端学习体验</p>
      </div>

      <div class="app-download-grid">
        <div class="platform-card">
          <div class="platform-icon android-icon">
            <i class="el-icon-mobile-phone"></i>
          </div>
          <h2>Android 下载</h2>
          <p class="platform-desc">请使用安卓设备扫码下载并安装应用</p>
          <div class="qr-wrapper">
            <img :src="androidQr" alt="安卓下载二维码" class="qr-image">
          </div>
          <div class="platform-tip">扫码后如浏览器拦截，请选择在浏览器中打开</div>
        </div>

        <div class="platform-card">
          <div class="platform-icon ios-icon">
            <i class="el-icon-apple"></i>
          </div>
          <h2>iOS 下载</h2>
          <!-- <p class="platform-desc">IOS版应用请在 APP STORE 搜索“悉迹AI”下载安装</p> -->
          <div class="ios-message-box">
            IOS版应用请在 APP STORE 搜索“悉迹AI”下载安装
          </div>
        </div>
      </div>

      <div class="page-actions">
        <el-button type="primary" round @click="goBack">返回上一页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppDownload',
  data() {
    return {
      androidQr: `${process.env.BASE_URL}Androidlink.jpg`
    }
  },
  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.app-download-page {
  min-height: 100vh;
  padding: 40px 20px;
  background: linear-gradient(135deg, #f5f7ff 0%, #eef3ff 45%, #f9fbff 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.app-download-card {
  width: 100%;
  max-width: 1080px;
  background: #fff;
  border-radius: 28px;
  box-shadow: 0 20px 60px rgba(51, 72, 120, 0.14);
  padding: 40px;
  box-sizing: border-box;
}

.app-download-header {
  text-align: center;
  margin-bottom: 36px;
}

.app-download-header h1 {
  margin: 0 0 12px;
  font-size: 34px;
  line-height: 1.2;
  color: #1f2d3d;
  font-weight: 700;
}

.app-download-header p {
  margin: 0;
  font-size: 16px;
  color: #6b7280;
}

.app-download-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
}

.platform-card {
  border: 1px solid #edf1f7;
  border-radius: 24px;
  padding: 32px 24px;
  text-align: center;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
}

.platform-icon {
  width: 72px;
  height: 72px;
  border-radius: 22px;
  margin: 0 auto 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 34px;
}

.android-icon {
  background: linear-gradient(135deg, #34c759 0%, #19b955 100%);
}

.ios-icon {
  background: linear-gradient(135deg, #5b8cff 0%, #7b61ff 100%);
}

.platform-card h2 {
  margin: 0 0 10px;
  font-size: 26px;
  color: #111827;
}

.platform-desc {
  margin: 0 0 20px;
  color: #6b7280;
  font-size: 15px;
  line-height: 1.7;
}

.qr-wrapper {
  width: 260px;
  height: 260px;
  margin: 0 auto 16px;
  background: #fff;
  border-radius: 20px;
  border: 1px solid #eef2f8;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.qr-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.platform-tip {
  font-size: 13px;
  color: #909399;
  line-height: 1.6;
}

.ios-message-box {
  min-height: 260px;
  border-radius: 20px;
  background: linear-gradient(135deg, #f3f7ff 0%, #eef2ff 100%);
  border: 1px solid #e3eafc;
  color: #334155;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.8;
  padding: 32px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-sizing: border-box;
}

.page-actions {
  display: flex;
  justify-content: center;
  margin-top: 32px;
}

@media (max-width: 768px) {
  .app-download-page {
    padding: 20px 12px;
    align-items: flex-start;
  }

  .app-download-card {
    padding: 24px 16px;
    border-radius: 20px;
  }

  .app-download-header h1 {
    font-size: 28px;
  }

  .app-download-grid {
    grid-template-columns: 1fr;
  }

  .qr-wrapper {
    width: 220px;
    height: 220px;
  }

  .ios-message-box {
    min-height: 180px;
    font-size: 18px;
  }
}
</style>
